{
  "welcome": "Bienvenue sur Djayma",
  "greeting": "Nanga def !",
  "tagline": "Tout ce qu'il vous faut, livré chez vous",
  "search": "Rechercher un produit...",
  "voice_search": "Recherche vocale",
  "cart": "Panier",
  "my_account": "Mon compte",
  "login": "Connexion",
  "register": "Inscription",
  "logout": "Déconnexion",
  "buy_now": "Acheter",
  "add_to_cart": "Ajouter au panier",
  "added_to_cart": "Ajouté au panier",
  "view_cart": "Voir le panier",
  "articles": "articles",
  "items": "articles",
  "close": "Fermer",
  "fcfa": "FCFA",
  "loading": "Chargement...",
  "error": "Une erreur est survenue",
  "retry": "Réessayer",
  "back_home": "Retour à l'accueil",
  "not_found": "Page introuvable",
  "not_found_desc": "Cette page n'existe pas ou a été déplacée.",
  "privacy_policy": "Politique de confidentialité",
  "terms": "Conditions générales",
  "contact": "Contact",
  "phone": "Téléphone",
  "email": "Email",
  "address": "Adresse",
  "language": "Langue",
  "all_brands": "Toutes les marques",
  "all_products": "Tous les produits",
  "footer_desc": "Votre marché digital — Produits de qualité livrés chez vous à Dakar.",
  "newsletter": "Newsletter",
  "newsletter_placeholder": "Votre email",
  "subscribe": "S'abonner",
  "rights": "Tous droits réservés",
  "your_cart": "Votre Panier",
  "cart_empty": "Votre panier est vide",
  "cart_empty_desc": "Parcourez notre catalogue et ajoutez des produits pour commencer votre commande.",
  "see_catalog": "Voir le catalogue",
  "articles_count_one": "{{count}} article",
  "articles_count_other": "{{count}} articles",
  "articles_count": "{{count}} article",
  "articles_count_plural": "{{count}} articles",
  "subtotal": "Sous-total HT",
  "tva": "TVA (18%)",
  "total_ttc": "Total TTC",
  "delivery_label": "Livraison",
  "delivery_next_step": "Calculée à l'étape suivante",
  "min_order_warning": "Commande minimum : {{amount}}. Il vous manque {{remaining}}.",
  "min_units": "Minimum : {{count}} unités",
  "continue_shopping": "Continuer les achats",
  "decrease_qty": "Diminuer la quantité",
  "discover": "Découvrir",
  "increase_qty": "Augmenter la quantité",
  "menu": "Menu",
  "quantity_label": "Quantité: {{count}}",
  "proceed_to_order": "Passer la commande",
  "total_weight": "Poids total : {{weight}} kg",
  "remove_item": "Supprimer",
  "summary": "Récapitulatif",
  "call_us": "Appelez-nous",
  "error": {
    "generic_title": "Une erreur est survenue",
    "refresh_page": "Rafraîchir la page"
  },
  "errors": {
    "rateLimited": "Trop de requêtes. Veuillez patienter {{seconds}} secondes.",
    "serverError": "Une erreur est survenue. Veuillez réessayer.",
    "unauthorized": "Session expirée. Veuillez vous reconnecter.",
    "networkError": "Problème de connexion. Vérifiez votre internet."
  },
  "accessibility": {
    "skip_to_content": "Aller au contenu"
  },
  "contact_page": {
    "seo_title": "Contact",
    "seo_description": "Contactez CIEDA — Compagnie Import Export & Distribution Africaine. Dakar, Sénégal.",
    "title": "Contactez-nous",
    "subtitle": "Une question, une commande spéciale ou un besoin grossiste ? Notre équipe vous répond rapidement.",
    "call": {
      "title": "Appelez-nous",
      "description": "Parlez directement à notre équipe commerciale en français ou en wolof."
    },
    "whatsapp": {
      "title": "WhatsApp",
      "description": "Le moyen le plus rapide pour confirmer une commande ou poser une question produit.",
      "cta": "Ouvrir WhatsApp"
    },
    "email": {
      "title": "E-mail",
      "description": "Envoyez-nous un message détaillé et nous vous répondons sous 24h ouvrées."
    },
    "address": {
      "title": "Adresse",
      "description": "Compagnie Import Export & Distribution Africaine — Hann Mariste II, Dakar, Sénégal."
    },
    "hours": {
      "title": "Horaires",
      "weekdays": "Lundi – Vendredi : 8h – 18h (GMT)",
      "weekend": "Samedi : 9h – 14h (GMT) · Dimanche : fermé"
    }
  },
  "not_found": {
    "seo_title": "Page introuvable",
    "seo_description": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "title": "Page introuvable",
    "prefix": "La page",
    "suffix": "n'existe pas ou a été déplacée.",
    "back_home": "Retourner à l'accueil",
    "view_catalog": "Voir le catalogue",
    "popular_heading": "Pages populaires",
    "popular": {
      "home": "Accueil",
      "catalog": "Catalogue produits",
      "cart": "Mon panier",
      "account": "Mon compte",
      "privacy": "Politique de confidentialité",
      "terms": "Conditions générales"
    }
  }
}
